import { QChartTemplatesRFC } from "./QChartTemplatesRFC.js";

export class QGetChartTemplatesRFC extends QChartTemplatesRFC {
  constructor() {
    super();
    this.fApplyTemplate = false;
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);

    var success = r["success"];

    callBackObj.DownloadChartTemplatesResult(success, r["data"], this.fApplyTemplate);
  }
}
